import React from 'react';

import Box from '@mui/material/Box';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import Typography from '@mui/material/Typography';

type Props = {
  label: string;
  options: (string | number)[];
  value?: string | number;
};

/**
 * ガイド画面で表示用のモックToggleButtonGroup（操作不能）
 */
const GuideMockToggleButtonGroup: React.FC<Props> = ({ label, options, value }) => {
  return (
    <Box sx={{ pointerEvents: 'none' }}>
      <Typography variant="caption" color="text.secondary" fontWeight={500}>
        {label}
      </Typography>
      <ToggleButtonGroup
        value={value ?? options[options.length - 1]}
        exclusive
        size="small"
        sx={{ mt: 0.5, display: 'flex' }}
      >
        {options.map((opt) => (
          <ToggleButton
            key={opt}
            value={opt}
            sx={{ flex: 1, textTransform: 'none', fontWeight: 600, borderRadius: 2 }}
          >
            {opt}
          </ToggleButton>
        ))}
      </ToggleButtonGroup>
    </Box>
  );
};

export default GuideMockToggleButtonGroup;
